const now = new Date()



function genNoWork() {
    let noWork = [
        [1, 1, 26],
        [11, 27, 25],
        [9, 1, 25],
        [11, 11, 25],
        [12, 25, 25],


    ]
    return noWork.map(day => {

        return {

            allday: true,
            title: 'No Work',
            start: new Date(2000 + day[2], day[0] - 1, day[1], 0, 0, 0),
            end: new Date(2000 + day[2], day[0] - 1, day[1] + 1, 0, 0, 0)
        }
    })

}

function genGLC() {
    let glc = [
        [9, 6, 25],


    ]
    return glc.map(day => {

        return {

            allday: true,
            title: 'GLC',
            start: new Date(2000 + day[2], day[0] - 1, day[1], 0, 0, 0),
            end: new Date(2000 + day[2], day[0] - 1, day[1] + 1, 0, 0, -1000)
        }
    })

}

function genNoSchool() {
    let noSchoolDays = [
        [9, 7, 26],
        [9, 21, 26],
        [10, 16, 26],
        [11, 2, 26],
        [11, 3, 26],




        [1, 18, 27],
        [1, 25, 27],
        [2, 15, 27],

        [3, 9, 27],

        [4, 12, 27],
        [4, 22, 27],
        [5, 17, 27],
        [5, 31, 27],


    ]
    return noSchoolDays.map(day => {

        return {

            allday: true,
            title: 'No School',
            start: new Date(2000 + day[2], day[0] - 1, day[1], 0, 0, 0),
            end: new Date(2000 + day[2], day[0] - 1, day[1], 0, 0, 0)
        }
    })

}

export default [

    ...genNoSchool(),
    ...genGLC(),
    ...genNoWork(),
    {

        allday: true,
        title: 'Early Release',
        start: new Date("9/18/2026"),
        end: new Date("9/18/2026")
    },
    {

        allday: true,
        title: 'Early Release',
        start: new Date("11/23/2026"),
        end: new Date("11/23/2026")
    },
    {

        allday: true,
        title: 'Early Release',
        start: new Date("11/24/2026"),
        end: new Date("11/24/2026")
    },
    {

        allday: true,
        title: 'Early Release',
        start: new Date("11/25/2026"),
        end: new Date("11/25/2026")
    },
    {

        allday: true,
        title: 'Early Release',
        start: new Date("12/23/2026"),
        end: new Date("12/23/2026")
    },
    {

        allday: true,
        title: 'Early Release',
        start: new Date("2/26/2027"),
        end: new Date("2/26/2027")
    },
    {

        allday: true,
        title: 'Early Release - Last Day',
        start: new Date("6/17/2026"),
        end: new Date("6/17/2026")
    },
    {

        allday: true,
        title: 'Early Release',
        start: new Date("6/18/2026"),
        end: new Date("6/18/2026")
    },
    {

        allday: true,
        title: 'Parents',
        start: new Date("6/22/2026"),
        end: new Date("6/26/2026")
    },
    {

        allday: true,
        title: 'BarT',
        start: new Date("8/17/2026"),
        end: new Date("8/21/2026")
    },

    {

        allday: true,
        title: 'First Day of School',
        start: new Date("8/25/2026"),
        end: new Date("8/25/2026")
    },


    {

        allday: true,
        title: 'Woodland Camp',
        start: new Date("8/3/2026"),
        end: new Date("8/7/2026")
    },
    {

        allday: true,
        title: 'Makeup days',
        start: new Date("6/14/2027"),
        end: new Date("6/18/2027")
    },
    {

        allday: true,
        title: 'Spring Break',
        start: new Date("3/26/2027"),
        end: new Date("4/4/2027")
    },
    {

        allday: true,
        title: 'Christmas Break',
        start: new Date("12/24/2026"),
        end: new Date("1/3/2027")
    },
    {

        allday: true,
        title: 'Thanksgiving Break',
        start: new Date("11/26/2026"),
        end: new Date("11/29/2026")
    },
    {

        allday: true,
        title: 'GLC Event',
        start: new Date("10/3/2026"),
        end: new Date("10/3/2026")
    },
    {

        allday: true,
        title: 'GLC Event',
        start: new Date("12/5/2026"),
        end: new Date("12/5/2026")
    },
    ...([
        "9/27/2026",
        "9/20/2026",
        "10/04/2026",
        "10/11/2026",
        "10/18/2026",
        "10/25/2026",
        "11/01/2026",
        "11/08/2026",


    ].map(date => ({

        allday: true,
        title: 'Soccer',
        start: new Date(date),
        end: new Date(date)
    }))),

    ...([
        "9/30/2026",
        "10/7/2026",
        "10/14/2026",
        "10/21/2026",
        "10/28/2026",
        "11/4/2026",



    ].map(date => ({

        allday: true,
        title: 'Art',
        start: new Date(date),
        end: new Date(date)
    }))),

    ...([
        "9/26/2026",

        "10/10/2026",
        "10/17/2026",
        "10/24/2026",
        "10/31/2026",
        "11/7/2026",
        "11/14/2026",
        "11/21/2026",
        "12/12/2026",
        "12/19/2026",
        "1/9/2027",
        "1/16/2027",
        "1/23/2027",
        "1/30/2027",
        "2/6/2027",
        "2/20/2027",
        "2/27/2027",
        "3/6/2027",
        "3/13/2027",
        "3/20/2027",
        "4/3/2027",
        "4/10/2027",
        "4/17/2027",
        "4/21/2027",
        "5/1/2027",
        "5/8/2027",
        "5/15/2027",
        "5/22/2027",







    ].map(date => ({

        allday: true,
        title: 'GLC',
        start: new Date(date),
        end: new Date(date)
    })))





    /*
    {

        allday: true,
        title: 'Beth Weekend',
        private: true,
        start: new Date("10/18/2025"),
        end: new Date("10/22/2025")
    },
    {
        allday: true,
        title: 'Ren Fest',
        start: new Date("10/5/2025"),
        private: true,
        end: new Date("10/5/2025")
    },
    {
        allday: true,
        title: 'Beth Date',
        start: new Date("9/5/2025"),
        private: true,
        end: new Date("9/5/2025")
    },
    {
        allday: true,
        title: 'Beth`s Katie',
        start: new Date("9/19/2025"),
        private: true,
        end: new Date("9/20/2025")
    },
    {
        allday: true,
        title: 'Glazing',
        start: new Date('10/3/2025'),
        private: true,
        end: new Date('10/3/2025')
    },

*/

]